// wizardRegistry — typed lookup `{[wizard_id]: { manifest, Component }}` for
// the 5 v2 wizards. As of CHG-1324 (Phase 1B), each per-wizard Component
// is imported from its `<wizard-id>.generated.tsx` module emitted by the
// CHG-1319 wizard runtime generator (tools/v2-gen/v2genwiz.py). The
// CHG-1247 hand-rolled wizards are retired in this CHG.
//
// Pages consume via `wizardRegistry[wizardId].Component` plus `useWizard`
// for open/close state. The registry is the single import surface so the
// barrel of per-wizard components doesn't leak into page files.

import type { ComponentType } from "react";
import type { WizardManifest } from "./manifestTypes";

import { campaignCreateManifest } from "../generated/wizardManifests";
import { donorCreateManifest } from "../generated/wizardManifests";
import { recurringDonationCreateManifest } from "../generated/wizardManifests";
import { pledgeCreateManifest } from "../generated/wizardManifests";
import { importMapManifest } from "../generated/wizardManifests";

import { CampaignCreateWizard } from "./campaign-create.generated";
import { DonorCreateWizard } from "./donor-create.generated";
import { RecurringDonationCreateWizard } from "./recurring-donation-create.generated";
import { PledgeCreateWizard } from "./pledge-create.generated";
import { ImportMapWizard } from "./import-map.generated";

export interface WizardComponentProps {
  open: boolean;
  onClose: () => void;
}

export interface WizardRegistryEntry {
  wizard_id: string;
  manifest: WizardManifest;
  Component: ComponentType<WizardComponentProps>;
}

export const wizardRegistry: Record<string, WizardRegistryEntry> = {
  "campaign-create": {
    wizard_id: "campaign-create",
    manifest: campaignCreateManifest,
    Component: CampaignCreateWizard,
  },
  "donor-create": {
    wizard_id: "donor-create",
    manifest: donorCreateManifest,
    Component: DonorCreateWizard,
  },
  "recurring-donation-create": {
    wizard_id: "recurring-donation-create",
    manifest: recurringDonationCreateManifest,
    Component: RecurringDonationCreateWizard,
  },
  "pledge-create": {
    wizard_id: "pledge-create",
    manifest: pledgeCreateManifest,
    Component: PledgeCreateWizard,
  },
  "import-map": {
    wizard_id: "import-map",
    manifest: importMapManifest,
    Component: ImportMapWizard,
  },
};

export type WizardId = keyof typeof wizardRegistry;
